import { useEffect, useState } from 'react'

export const useViewportHeightCalc = ({ difference }: { difference: number }) => {
  const [height, setHeight] = useState(window.innerHeight - difference)

  useEffect(() => {
    const handleResize = () => setHeight(window.innerHeight - difference)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [difference])

  return height
}
